import type { Enums, Nullable } from "@msuite/utils/types";
import type { IconName } from "./icons";

export function getFulfillmentTypeIcon(
	fulfillmentType: Nullable<Enums<"serviceFulfillmentType">>,
): IconName {
	switch (fulfillmentType) {
		case "internal":
			return "Grid2x2";
		case "external":
			return "Blocks";
		default:
			return "HelpCircle";
	}
}
